import React from "react";
import "./App.css";
import Layout from "./pages/layout";
import Products from "./pages/products/index";

function App() {
  return (
    <Layout>
      <Products />
    </Layout>
  );
}

export default App;
